import { Component } from '@angular/core';

@Component({
  selector: 'app-about-dhaduk-family',
  templateUrl: './about-dhaduk-family.component.html',
  styleUrl: './about-dhaduk-family.component.scss'
})
export class AboutDhadukFamilyComponent {

}
